/**
 * Admin Message Handlers — ADMIN_MESSAGE_RECEIVED
 *
 * Listens for admin-to-user messages and updates the admin message store.
 */

import type { Socket } from "socket.io-client";
import { EVENTS } from "@/constants/events";
import { useAdminMessageStore, type AdminMessage } from "../adminMessageStore";

export function registerAdminMessageHandlers(socket: Socket): () => void {
  const store = useAdminMessageStore;

  const handleAdminMessage = (data: AdminMessage) => {
    store.getState().handleMessageReceived(data);
  };

  socket.on(EVENTS.ADMIN_MESSAGE_RECEIVED, handleAdminMessage);

  return () => {
    socket.off(EVENTS.ADMIN_MESSAGE_RECEIVED, handleAdminMessage);
  };
}
